<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters>
      <v-layout row>
        <v-col cols="12" sm="12" lg="12" class="pa-2 pb-0">
          <i-card-top
            class="d-flex"
            headerTitle
            :useBtnList="buttonUseList"
            @btnSearch="btnSearch(true)"
            @btnAdd="btnAdd()"
            @btnDelete="btnDelete()"
          >
            <template v-slot:body>
              <v-layout overflow-auto></v-layout>
            </template>
          </i-card-top>
        </v-col>
        <v-col cols="12" sm="12" lg="12" class="pa-2 pt-0">
          <i-card-vertical headerTitle="사업장 관리" device="web">
            <template v-slot:body>
              <v-layout column>
                <v-col cols="12" md="12" class="row pa-0">
                  <v-col cols="12" class="pa-0">
                    <DxDataGrid
                      id="companyDataGrid"
                      class="layout-col-height00"
                      :ref="dxDataGridRef"
                      :data-source="companys"
                      :remote-operations="false"
                      :hover-state-enabled="true"
                      :allow-column-reordering="true"
                      :allow-column-resizing="true"
                      :row-alternation-enabled="true"
                      :column-auto-width="true"
                      :show-borders="true"
                      :show-row-lines="true"
                      :selection="{ mode: 'single' }"
                      key-expr="id"
                      :focused-row-enabled="true"
                      @row-updating="onRowUpdating"
                      @editing-start="onEditingStart"
                      @editor-preparing="onEditorPreparing"
                      @content-ready="onContentReady"
                    >
                      <DxEditing
                        mode="batch"
                        :allow-updating="true"
                        :select-text-on-edit-start="true"
                      />

                      <DxSelection
                        :select-all-mode="allMode"
                        show-check-boxes-mode="always"
                        mode="multiple"
                      />
                      <DxColumn
                        data-field="save"
                        data-type="string"
                        width="160px"
                        alignment="center"
                        caption
                        :allow-editing="false"
                        cell-template="actionTemplete"
                      ></DxColumn>
                      <template #actionTemplete="{ data: cellInfo }">
                        <div>
                          <v-btn
                            color="btn_sub"
                            elevation="0"
                            dark
                            small
                            @click="btnDetail(cellInfo)"
                            class="mr-2 rounded"
                          >상세보기</v-btn>
                        </div>
                      </template>
                      <DxColumn
                        data-field="clntNm"
                        data-type="string"
                        width="120px"
                        alignment="left"
                        caption="고객 이름"
                        :allow-editing="false"
                      />

                      <DxColumn
                        data-field="compId"
                        data-type="string"
                        width="120px"
                        alignment="left"
                        caption="사업장 번호"
                        :allow-editing="false"
                      />

                      <DxColumn
                        data-field="compNm"
                        data-type="string"
                        width="120px"
                        alignment="left"
                        caption="사업장명"
                        :allow-editing="false"
                      />

                      <DxColumn
                        data-field="rpstNm"
                        data-type="string"
                        width="100px"
                        alignment="left"
                        caption="대표자"
                        :allow-editing="false"
                      />
                      <DxColumn
                        data-field="addrs1"
                        data-type="string"
                        alignment="left"
                        caption="주소"
                        :allow-editing="false"
                      />
                    </DxDataGrid>
                  </v-col>
                </v-col>
              </v-layout>
            </template>
          </i-card-vertical>
        </v-col>
      </v-layout>
    </v-row>
  </v-container>
</template>

<script>
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import { getCompanyList, deleteCompany } from '@/api/baseManage/compManage'
import { getClientId } from '@/api/setting/clientManage'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'compManage',
  components: {
    'i-card-vertical': iCardVertical,
    'i-card-top': iCardTop
  },
  data() {
    return {
      dxDataGridRef: 'companyDataGrid',
      companys: [],
      valid: true,
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnDelete' //삭제
      ],
      clientList: [],
      allMode: 'allPages'
    }
  },
  activated() {
    // 켜질때 조회
    this.btnSearch(true)
  },
  computed: {},
  beforeMount() {
    getClientId()
      .then(res => {
        if (res.success) {
          this.clientList = []
          this.clientList = res.list
        }
      })
      .catch(error => {})
  },
  mounted() { },
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //------------------------------------------
    //  사업장 조회
    //------------------------------------------
    btnSearch(isNotify) {
      this.openLoading('searching')
      this.companys = []
      let params = {
        clntId: this.getClntId(),
        grpAuth: this.getAuthCd()
      }

      getCompanyList(params, isNotify)
        .then(res => {
          if (res.success) {
            this.gridInit(this.GetDataGrid(this.dxDataGridRef))
            this.companys = res.list
            this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
          }
        })
        .catch(error => {})
        .finally(() => {
          this.endLoading()
        })
    },
    //------------------------------------------
    //  사업장 추가
    //------------------------------------------

    btnAdd() {
      let data = {}
      Object.defineProperty(data, '__created__', {
        value: true,
        writable: true,
        enumerable: true,
        configurable: true
      })
      const toRouter = {
        name: 'CompManageDetail',
        params: {
          data: data
        }
      }
      this.$router.push(toRouter)
    },
    async btnDetail(cellInfo) {
      const toRouter = {
        name: 'CompManageDetail',
        params: {
          data: cellInfo.data
        }
      }
      this.$router.push(toRouter)
    },
    //------------------------------------------
    //  사업장 삭제
    //------------------------------------------
    btnDelete() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then(selectedRows => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'info')
            return
          }
          this.vToastifyPrompt(
            this.$t('사업장을 삭제하시겠습니까?'),
            'info',
            current => {
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              this.openLoading('deleting')
              //삭제 api
              deleteCompany(selectedRows, true)
                .then(res => {
                  if (res.success) {
                    this.deleteCallBack(selectedRows)
                    this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
                  }
                })
                .catch(error => {})
                .finally(() => {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
                  this.endLoading()
                })
            },
            null,
            true
          )
        })
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    deleteCallBack(param) {
      var index = null
      param.forEach(key => {
        index = this.companys.findIndex(obj => obj == key)
        this.companys.splice(index, 1)
      })
    }
  }
}
</script>

<style scoped></style>
